import { render, staticRenderFns } from "./QiniuSettings.vue?vue&type=template&id=6fbbc5dc&scoped=true"
import script from "./QiniuSettings.vue?vue&type=script&lang=js"
export * from "./QiniuSettings.vue?vue&type=script&lang=js"
import style0 from "./QiniuSettings.vue?vue&type=style&index=0&id=6fbbc5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbbc5dc",
  null
  
)

export default component.exports